function pushEvent(args: object) {
  try {
    const dataLayer = window.dataLayer;

    if (dataLayer && typeof dataLayer.push === "function") {
      dataLayer.push(args);
      // console.log("PUSHING EVENT", args);
    }
  } catch (err) {
    console.warn("pushEvent error", err);
  }
}

export default {
  pushEvent,
};
